import { render } from "./LandingPage.vue?vue&type=template&id=5afb87a4&scoped=true"
const script = {}

import "./LandingPage.vue?vue&type=style&index=0&id=5afb87a4&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afb87a4"]])

export default __exports__